// @flow
import React, { Component } from 'react';
import Checkbox from "@material-ui/core/Checkbox";
import {SketchOrderDeliveryOptionValues} from "../../lib/SketchOrderDeliveryOptionValues";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from '@material-ui/core/FormControlLabel';

type deliveryOptionType = {
    key: string,
    value: string,
}

type Props = {
    sketchOrder: {
        deliveryOptions: Array<deliveryOptionType>,
    },
    onSketchOrderChange: Function,
};

const SketchOrderDeliveryOptionsSwitches = (props: Props) => {
    if(!props.sketchOrder || !props.sketchOrder.deliveryOptions)
        return null;
    return (
        <div>
            <Typography variant='body1'>Delivery Options:</Typography>
            {
                <div>
                    {SketchOrderDeliveryOptionValues.map(option => {
                        const optionIsChecked = props.sketchOrder.deliveryOptions.includes(option.value);
                        return (
                            <FormControlLabel control={<Checkbox
                                checked={optionIsChecked}
                                onChange={() => props.onSketchOrderChange(option.value, optionIsChecked)}
                            />} label={option.key}/>
                        );
                    })}
                </div>
            }
        </div>
    );
};

export default SketchOrderDeliveryOptionsSwitches;